import { render } from "./entry-stacked.vue?vue&type=template&id=2ad54082&scoped=true"
import script from "./entry-stacked.vue?vue&type=script&lang=js"
export * from "./entry-stacked.vue?vue&type=script&lang=js"

import "./entry-stacked.vue?vue&type=style&index=0&id=2ad54082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad54082"]])

export default __exports__